const autoNgTemplateLoaderTemplate1 = require('./git-form-ref-field.html');

export const gitFormRefField = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    value: '<',
    onChange: '<',
  },
};
